import React, { useState } from 'react';
import './DateFilter.css';

const DateFilter = ({ onFilter }) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onFilter(startDate, endDate);
  };

  const handleClear = () => {
    setStartDate('');
    setEndDate('');
    onFilter('', '');
  };

  // ローカル時間でYYYY-MM-DD形式の日付文字列を取得
  const getLocalDateString = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const handleToday = () => {
    const today = getLocalDateString(new Date());
    setStartDate(today);
    setEndDate(today);
    onFilter(today, today);
  };

  const handleThisWeek = () => {
    const today = new Date();
    const dayOfWeek = today.getDay();
    const startOfWeek = new Date(today);
    startOfWeek.setDate(today.getDate() - dayOfWeek);
    const endOfWeek = new Date(today);
    endOfWeek.setDate(today.getDate() - dayOfWeek + 6);

    const startStr = getLocalDateString(startOfWeek);
    const endStr = getLocalDateString(endOfWeek);

    setStartDate(startStr);
    setEndDate(endStr);
    onFilter(startStr, endStr);
  };

  return (
    <div className="date-filter">
      <form onSubmit={handleSubmit} className="date-filter-form">
        <div className="date-inputs">
          <div className="date-input-group">
            <label htmlFor="start-date">開始日:</label>
            <input
              id="start-date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="date-input"
            />
          </div>

          <div className="date-input-group">
            <label htmlFor="end-date">終了日:</label>
            <input
              id="end-date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="date-input"
            />
          </div>
        </div>

        <div className="date-buttons">
          <button type="submit" className="filter-button">
            🔍 検索
          </button>
          <button type="button" onClick={handleToday} className="quick-button">
            今日
          </button>
          <button type="button" onClick={handleThisWeek} className="quick-button">
            今週
          </button>
          <button type="button" onClick={handleClear} className="clear-button">
            クリア
          </button>
        </div>
      </form>
    </div>
  );
};

export default DateFilter;
